// in src/authClient.js
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import { envBaseURL, appName, userCookieName, roleCookieName } from '../AppConfig'
import Cookies from 'universal-cookie';
import { debug } from './pklog'

const localStorageTokenName = "id"

export default (type, params) => {
    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
        debug("AUTH_LOGIN", params)
        const { notif, username: id, password, confirm_password, token, reset_token } = params;

        const baseurl = envBaseURL()
        let url = undefined
        let body = undefined
        let notify_message = undefined
        if(token === 'request_password_reset') {
          body = JSON.stringify({ users_id: id })
          url = baseurl+"/request_reset_password"
        }
        else if (reset_token) {
          body = JSON.stringify({ users_id: id, new_password: password, confirm_new_password: confirm_password, token: reset_token })
          url = baseurl+"/reset_password"
          notify_message = "pk.reset_password_success"
        }
        else if (token) {
          body = JSON.stringify({ id, password, registrationtoken: token })
          url = baseurl+"/verify_user"
        }
        else {
          body = JSON.stringify({ id, password })
            url = baseurl+"/login"
        }

        const request = new Request(
           url,
           {
                method: 'POST',
                body: body,
                headers: new Headers({ 'Content-Type': 'application/json' }),
                credentials:'include',
                mode:'cors'
            }
          )
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                if(notify_message) {
                  console.log(notify_message)
                  // notify_message = translate(notify_message)
                  //   console.log(notify_message)
                  notif(notify_message);
                }
                return response.json();
            })
            .then(({ token }) => {
                localStorage.setItem(localStorageTokenName, id);
            });
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        debug("AUTH_LOGOUT")
        const cookies = new Cookies();
        cookies.set(userCookieName, {expires: new Date() })
        document.cookie = userCookieName+'=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        cookies.remove(userCookieName)
        cookies.remove(roleCookieName)
        cookies.remove(appName)
        localStorage.removeItem(localStorageTokenName);
        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        debug("AUTH_ERROR", params)
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem(localStorageTokenName);
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        debug("AUTH_CHECK", params.resource)
        //const cookies = new Cookies();
        //return cookies.get(userCookieName) && cookies.get(appName) ? Promise.resolve() : Promise.reject();
        return Promise.resolve()
    }

        // role = admin/teacher/none userId=public/x/none
        // admin, public -> role(admin)
        // admin, x -> role(admin)
        // admin, none -> role(admin)
        // teacher, public -> role(teacher)
        // teacher, x -> teacher
        // teacher, none -> role(teacher)
        // none, public -> role(none)
        // none, x -> teacher
        // none, none -> none
        // const userLookup = {
        //   public: null,
        //   null: null
        // }
        // const default_permission = "teacher"
    if (type === AUTH_GET_PERMISSIONS) {
        const cookies = new Cookies();
        const role = cookies.get(roleCookieName)
        const userId = cookies.get(userCookieName)
        console.log("AUTH_GET_PERMISSIONS role:", role, userId)
        if(role !== 'admin' && userId && userId !== 'public') {
          return Promise.resolve('teacher')
        }
        return Promise.resolve(role);
    }
    return Promise.reject('Unknown method');
};
